import { Component } from 'react';
import * as Sentry from '@sentry/react';

export default class ErrorBoundary extends Component {
  state = { hasError: false, error: null };
  props: any;

  static getDerivedStateFromError(error) {
    return {
      hasError: true,
      error,
    };
  }
  componentDidCatch(error, info) {
    Sentry.captureReactException(error, info);
  }

  render() {
    if(this.state.hasError) {
      return this.props.fallback;
    }
    return this.props.children;
  }
}
